define('lib/jquery.timeago.nl',['jquery', 'lib/jquery.timeago'], function($) {
// Dutch
jQuery.timeago.settings.strings = {
  prefixAgo: null,
  prefixFromNow: "over",
  suffixAgo: "geleden",
  suffixFromNow: null,
  seconds: "minder dan een minuut",
  minute: "een minuut",
  minutes: "%d minuten",
  hour: "een uur",
  hours: "%d uur",
  day: "een dag",
  days: "%d dagen",
  month: "een maand",
  months: "%d maanden",
  year: "een jaar",
  years: "%d jaar",
  wordSeparator: " ",
  numbers: []
};
});
